import { ModuleWithProviders, NgModule } from '@angular/core';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { LongOperationModule } from 'src/app/common/long-operations/long-operations.module';
import { PipesModule } from 'src/app/common/pipes/pipes.module';
import { FormsConstructorModule } from 'src/app/forms/forms-constructor.module';
import { SharedModule } from 'src/app/shared.module';
import { CardsModule } from 'src/app/views/cards/cards.module';
import { GridUsersListModule } from 'src/app/views/grid-user-list/grid-users-list.module';
import { SortElementsModule } from 'src/app/views/sort-elements/sort-elements.module';
import { TableUsersListModule } from 'src/app/views/table-users-list/table-users-list.module';
import { ViewsModule } from 'src/app/views/views.module';
import { FormsAttributeService } from '../../forms/forms-attribute.service';
import { PostsModule } from '../posts/posts.module';
import { ProjectsModule } from '../projects/projects.module';
import { CommunitiesComponent } from './communities/communities.component';
import { CommunityFocusComponent } from './community-focus/community-focus.component';
import { CreateCommunityComponent } from './create-community/create-community.component';
import { DetailsCommunityComponent } from './details-community/details-community.component';
import { InfoCommunityComponent } from './info-community/info-community.component';
import { ManageCommunityComponent } from './manage-community/manage-community.component';
import { UpdateCommunityComponent } from './update-community/update-community.component';

@NgModule({
  declarations: [
    CommunitiesComponent,
    CreateCommunityComponent,
    ManageCommunityComponent,
    DetailsCommunityComponent,
    InfoCommunityComponent,
    UpdateCommunityComponent,
    CommunityFocusComponent,
  ],
  imports: [
    NgbPaginationModule,
    FormsConstructorModule,
    PostsModule,
    PipesModule,
    ProjectsModule,
    SharedModule,
    CardsModule,
    ViewsModule,
    TableUsersListModule,
    SharedModule,
    GridUsersListModule,
    LongOperationModule,
    SortElementsModule,
  ],
})
export class CommunityModule {
  public static forRoot(): ModuleWithProviders<CommunityModule> {
    return {
      ngModule: CommunityModule,
      providers: [FormsAttributeService],
    };
  }
}
